"use client";

// /share: a shared link, opened by someone who may have never seen innernet.
// It keeps the root layout, so the ground and type stay, retries quietly (1.5s,
// 4s, 10s) while the tab is visible, and only then offers a button. See
// components/brand/NettiError.tsx.

import { RouteError } from "../../components/brand/NettiError";

export default function ShareError(props: { error: Error & { digest?: string }; unstable_retry: () => void }) {
  return <RouteError {...props} where="share" />;
}
